export function cardStyle(
  loading: boolean = false,
  ok: boolean,
  kinda?: boolean,
) {
  if (loading) {
    return { color: 'grey' };
  } else if (kinda) {
    return { color: 'warning', icon: 'warning' };
  }

  return ok
    ? { color: 'success', icon: 'check' }
    : { color: 'error', icon: 'error' };
}
